<p>create-user-template works!</p>
